import React from "react";

const HashtagGrid = () => {
  const hashtags = [
    "HeartyEarth",
    "ThankU4BeingU",
    "Aspire2Inspire",
    "InspireInclusion",
    "ShareTheLove",
    "BeTheChange",
    "ThinkGlobalActLocal",
    "Community",
    "Ambassadors",
    "WOCA",
    "SOCA",
    "OxfordCityLarder",
    "CraftyLouise",
    "JerichoPantry",
    "HinkseyParkLarder",
    "SurplusCurry",
    "SurplusPudding",
    "CurryBikers",
    "FeelGoodBikes",
    "BrookesPathways",
    "SurplusEV",
    "PassItOn",
    "OxfordCityFridge",
    "Oxford",
    "Oxfordshire",
  ];

  return (
    <div className="d-flex flex-wrap gap-2">
      {hashtags.map((tag, index) => (
        <div className="hashtag-link" key={index}
          onClick={() =>
            window.open(
              `https://www.facebook.com/hashtag/${tag}?locale=en_GB`,
              "_blank"
            )
          }
        >
          <span className="hashtag-small">
            #{tag}
          </span>
        </div>
      ))}
    </div>
  );
};

export default HashtagGrid;
